import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { QueryContextFromKeys, QueryParamModel } from 'models';
import { sapUploadService } from 'services';

type SapUploadQueryContexts = QueryContextFromKeys<typeof sapUploadKeys>;

export const sapUploadKeys = {
  all: [{ scope: 'sapUpload' }] as const,
  lists: () => [{ ...sapUploadKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) => [{ ...sapUploadKeys.lists()[0], params }] as const,
};

const fetchJobList = async ({ queryKey: [{ params }] }: SapUploadQueryContexts['list']) =>
  sapUploadService.getSapJobList(params);

export const useJobList = (params?: QueryParamModel | null) =>
  useQuery({
    queryKey: sapUploadKeys.list(params),
    queryFn: fetchJobList,
    enabled: !!params?.filter,
  });

export const useSapUpload = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => sapUploadService.triggerSapUpload(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sapUploadKeys.lists() });
    },
  });
};

const fetchSapStatisticsList = async ({
  queryKey: [{ params }],
}: SapUploadQueryContexts['list']) => {
  return sapUploadService.getSapStatisticList(params);
};

export const useSapStatisticsPageList = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: sapUploadKeys.list(params),
    queryFn: fetchSapStatisticsList,
    enabled: !!params?.filter,
  });
};
